import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line camelcase
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { useNavigate } from 'react-router-dom';
import { MaterialReactTable } from 'material-react-table';
import { Box } from '@mui/material';
import setIndicatorColor from './utils';
import { getDashboardGeneralTable, setDashboardNodeSelected } from '../../../store/fuse/dashboard';

const DynamicTable = ({ height, redirect }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableData = useSelector((state) => state?.fuse?.dashboard?.dashboard?.generalTable);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);
  const currentMetricThresholds = useSelector((state) => state?.fuse?.dashboard?.metricThresholds);

  const aggregatedMetricIndicatorType = (rows, metric) => {
    if (rows.find((row) => setIndicatorColor(Number(row.original[metric]), metric, currentMetricThresholds) === 'red-primary')) {
      return 'red-primary';
    }
    if (rows.find((row) => setIndicatorColor(Number(row.original[metric]), metric, currentMetricThresholds) === 'yellow-primary')) {
      return 'yellow-primary';
    }
    if (rows.find((row) => setIndicatorColor(Number(row.original[metric]), metric, currentMetricThresholds) === 'green-primary')) {
      return 'green-primary';
    }
    return 'grey-primary';
  };

  const columns = [
    {
      header: 'Entidad',
      accessorKey: 'entidad',
      GroupedCell: ({ cell, table }) => (
        <>
          <strong>{cell.getValue()}</strong>
        </>
      ),
      size: 70,
    },
    {
      header: 'Region',
      accessorKey: 'region',
      GroupedCell: ({ cell, table }) => (
        <>
          <strong>{cell.getValue()}</strong>
        </>
      ),
      size: 70,
    },
    {
      header: 'Grupo',
      accessorKey: 'grupo',
      GroupedCell: ({ cell, table }) => (
        <>
          <strong>{cell.getValue()}</strong>
        </>
      ),
      size: 90,
    },
    {
      header: 'Inmueble',
      accessorKey: 'inmueble',
      GroupedCell: ({ cell }) => {
        return (
          <strong>{`${cell?.row?.original?.inmuebleid} - ${cell?.row?.original?.inmueble}`}</strong>
        );
      },
      size: 300,
    },
    {
      header: 'Servicio',
      accessorKey: 'servicio',
      GroupedCell: ({ cell, row }) => (
        <>
          <strong>{cell.getValue()}</strong>
        </>
      ),
      size: 90,
    },
    {
      header: 'Equipo',
      accessorKey: 'dispositivo',
      GroupedCell: ({ cell, row }) => (
        <>
          <strong>{cell.getValue()}</strong>
        </>
      ),
      size: 70,
    },
    {
      header: 'Total de dispositivos',
      accessorKey: 'totalDevices',
      AggregatedCell: ({ cell, table }) => <>{cell.row.leafRows.length}</>,
      // customize normal cell render on normal non-aggregated rows
      Cell: () => <>1</>,
      size: 70,
    },
    {
      header: 'Numero de Nodo',
      accessorKey: 'nodeid',
      size: 70,
    },
    {
      header: 'IP',
      accessorKey: 'ip',
      size: 80,
    },
    {
      header: 'Descripción Nodo',
      accessorKey: 'dsnodo',
      size: 90,
    },
    {
      header: 'CPU',
      accessorKey: 'cpu',
      AggregatedCell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={aggregatedMetricIndicatorType(cell.row.leafRows, 'cpu')} />{' '}
          </Box>
        );
      },
      Cell: ({ cell }) => {
        const i = cell.getValue();
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={setIndicatorColor(Number(i), 'cpu', currentMetricThresholds)} />{' '}
          </Box>
        );
      },
      size: 70,
    },
    {
      header: 'Mem',
      accessorKey: 'memoria',
      AggregatedCell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={aggregatedMetricIndicatorType(cell.row.leafRows, 'memoria')} />{' '}
          </Box>
        );
      },
      Cell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={setIndicatorColor(Number(cell.getValue()), 'memoria', currentMetricThresholds)} />{' '}
          </Box>
        );
      },
      size: 70,
    },
    {
      header: 'Disponibilidad',
      accessorKey: 'disponibilidad',
      AggregatedCell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={aggregatedMetricIndicatorType(cell.row.leafRows, 'disponibilidad')} />{' '}
          </Box>
        );
      },
      Cell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={setIndicatorColor(Number(cell.getValue()), 'disponibilidad', currentMetricThresholds)} />{' '}
          </Box>
        );
      },
      size: 70,
    },
    {
      header: 'Lat',
      accessorKey: 'latencia',
      AggregatedCell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={aggregatedMetricIndicatorType(cell.row.leafRows, 'latencia')} />{' '}
          </Box>
        );
      },
      Cell: ({ cell }) => {
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={setIndicatorColor(Number(cell.getValue()), 'latencia', currentMetricThresholds)} />{' '}
          </Box>
        );
      },
      size: 70,
    },
    {
      header: '% Perdida de paquetes',
      accessorKey: 'porcenloss',
      Cell: ({ cell }) => (
        <>
          <strong>{cell.getValue() || 0}%</strong>
        </>
      ),
      size: 70,
    },
  ];

  const handleOnRowClick = (event, row) => {
    event.preventDefault();
    if (!row.leafRows) {
      dispatch(setDashboardNodeSelected(redirect, 'Nodo'));
      navigate(`/dashboard/${row.original.nodeid}`);
    }
  };

  const tableStyle = {
    backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
  };
  
  return (
    <>
      <MaterialReactTable
        // eslint-disable-next-line camelcase
        localization={MRT_Localization_ES}
        columns={columns}
        data={tableData}
        enableColumnResizing
        enableGrouping
        enableStickyHeader
        enableStickyFooter
        enablePagination
        initialState={{
          density: 'compact',
          columnVisibility: { region: false, grupo: false },
          expanded: false, // expand all groups by default
          grouping: ['entidad'], // an array of columns to group by by default (can be multiple)
          pagination: { pageIndex: 0, pageSize: 100 },
          sorting: [{ id: 'totalDevices', desc: true }], // sort by state by default
        }}
        muiToolbarAlertBannerChipProps={{ color: 'primary' }}
        muiTableContainerProps={{ sx: { maxHeight: height || 700 } }}
        enableFullScreenToggle={false}
        muiTopToolbarProps={{
          sx: {
            tableStyle
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            tableStyle
          },
        }}
        muiTableBodyRowProps={({ row }) => ({
          onClick: (event) => {
            handleOnRowClick(event, row);
          },
          sx: {
            cursor: 'pointer',
          },
        })}
      />
    </>
  );
};

export default DynamicTable;
